export const SKIP_EFFECT_TOKEN = Symbol('skip token');

export function isSkipToken(target: unknown): target is typeof SKIP_EFFECT_TOKEN {
    return target === SKIP_EFFECT_TOKEN;
}

export function isPromise<T>(target: unknown): target is Promise<T> {
    return target instanceof Promise;
}
